// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/Organization.yaml
// Generated: 2026-10-19T08:02:09.747Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateOrganization, UpdateOrganization, Organization } from '@/types/forestry/Organization';

/**
 * Organization Service
 * CRUD operations for Organization via the ABP API.
 */
export const organizationService = new EntityService<Organization, CreateOrganization, UpdateOrganization>(
  '/api/forestry/organization',
  'Organization',
);
